<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'contactwire')"

  >

    <template #addDataForm>
      <contactWire-add-update></contactWire-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'contact_wire'">
            <template v-if="get(cell.item, 'id')">
                <contact-wire-cell :data="cell.item"></contact-wire-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'opora'">
            <template v-if="get(cell.value, 'id')">
                <pillar-cell :data="cell.value"></pillar-cell>
            </template>
        </template>
        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../contactWireStoreModule'
  import useContactWire from '../useContactWire'

  import ContactWireAddUpdate from '../components/ContactWireAddUpdate'
  import ContactWireCell from "@/views/apps/railway_structure/contactWire/components/ContactWireCell";

  import get from 'lodash.get'
  import UserCell from "@/views/apps/user/components/UserCell";
  import PillarCell from "@/views/apps/railway_structure/pillar/components/PillarCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        PillarCell,
        UserCell,
      ContactWireCell,
      ElementsLayout,
      ContactWireAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useContactWire();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
